import { useSelector } from "@xstate/store-react";
import { floatingPromptStore } from "./floating-prompt-store";

export const useFloatingPromptOpen = () => useSelector(floatingPromptStore, (s) => s.context.open);

export const useFloatingPromptTaskId = () => useSelector(floatingPromptStore, (s) => s.context.selectedTaskId);

export const useFloatingPromptActions = () => ({
  open: (taskId: string | null = null) => floatingPromptStore.send({ type: "prompt.open", taskId }),
  close: () => floatingPromptStore.send({ type: "prompt.close" }),
  toggle: () => floatingPromptStore.send({ type: "prompt.toggle" }),
  selectTask: (taskId: string) => floatingPromptStore.send({ type: "prompt.selectTask", taskId }),
});
